export default __webpack_public_path__ + "static/media/curve_laptop.c8462759.png";